import { CompanySettingsController } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

/**
 * Settings needed for insurance contracts and pension contracts.
 * @example
 * ```html
 * <salaxy-insurance-settings></salaxy-insurance-settings>
 * ```
 */

export class InsuranceSettings extends ComponentBase {

  /**
   * The following component properties (attributes in HTML) are bound to the Controller.
   * For detailed functionality, refer to [controller](#controller) implementation.
   */
  public bindings = {
    /**
     * Array of section ids to show
     * By default: ['pensionContracts','insuranceContracts']
     * All options:
     * 'pensionContracts': Pension related settings
     * 'yelPensionContracts': Pension related settings
     * 'insuranceContracts' : Insureance contract related settings
     */
    sections: "<",

    /** Sets the isReadOnlyForced status. */
    isReadOnlyForced:"<"
  };

  /** Uses the CompanySettingsController */
  public controller = CompanySettingsController;

  /** Default template is the view  */
  public defaultTemplate = "salaxy-components/settings/Insurances.html";

}
